import { getAppVersion } from '@/lib/helpers/getAppVersion.ts'

export default function AppVersion() {
  const version = getAppVersion()
  if (!version) {
    return <></>
  }
  // Tiny muted line — diagnostic info, not a primary element. Left-aligned
  // and the same width as the identity row so it flows as a subtle footer.
  //
  // The `data-harness-trigger="version"` attribute is the surface the
  // dev-harness 5-tap trigger listens for (see
  // `lib/devtools/harness/trigger.ts`). The attribute is unconditional
  // (no `__DEV_HARNESS__` gate here) because:
  //   - the HTML cost is one short attribute per render, negligible
  //   - the listener only exists in dev builds, so the attribute is
  //     inert in production (it's just data on the DOM node, no click
  //     handler will react to it)
  //   - keeping product components free of `__DEV_HARNESS__` branching
  //     is a style choice that makes the harness gating live entirely
  //     inside `lib/devtools/harness/`, not scattered across the app
  return (
    <span
      data-harness-trigger="version"
      className={`block w-full truncate text-[10px] text-muted-foreground`}
    >
      {version}
    </span>
  )
}
